/**
 * The cursor for a list's next page, or null when there is none. The search
 * API still hands back a cursor on its last page, so a page that came back
 * empty, or that brings the list up to the response's `total`, ends the list
 * — otherwise "Load more" stays live and only finds out by fetching nothing.
 *
 * `loadedBefore` is how many rows the list already held before this page.
 */
export function nextPageCursor(results, loadedBefore = 0) {
    const cursor = results?.LastEvaluatedKey || null;
    if (!cursor) return null;
    const count = results?.Items?.length || 0;
    if (count === 0) return null;
    const total = results?.total;
    if (typeof total === 'number' && Number.isFinite(total) && loadedBefore + count >= total) return null;
    return cursor;
}
